// src/components/common/StatusBanner.jsx
import React from "react";

const variants = {
    info: "bg-blue-50 text-blue-800",
    success: "bg-green-50 text-green-800",
    warning: "bg-yellow-50 text-yellow-800",
    danger: "bg-red-50 text-red-700",
};

function StatusBanner({ children, variant = "info", className = "" }) {
    const cls = variants[variant] || variants.info;
    return (
        <div className={`my-4 text-xl font-extrabold rounded p-3 ${cls} ${className}`}>
            {children}
        </div>
    );
}

export default StatusBanner;